
import React from 'react';
import { Form } from '@/components/ui/form';
import { usePremiumAccountForm } from '@/hooks/use-premium-account-form';
import { PlatformField } from './form-fields/PlatformField';
import { CTraderProfileField } from './form-fields/CTraderProfileField';
import { TradingAccountField } from './form-fields/TradingAccountField';
import { VolumeMultiplierField } from './form-fields/VolumeMultiplierField';
import { ReversePositionField } from '@/components/common/ReversePositionField';
import { FormActions } from './form-fields/FormActions';

interface PremiumAddAccountFormProps {
  botId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export const PremiumAddAccountForm = ({
  botId,
  onSuccess,
  onCancel
}: PremiumAddAccountFormProps) => {
  const {
    form,
    isLoadingTradingAccounts,
    tradingAccounts,
    isSubmitting,
    handleSubmit
  } = usePremiumAccountForm(botId, onSuccess);

  const watchCspAccount = form.watch('csp_account_id');

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
        <PlatformField form={form} />
        <CTraderProfileField form={form} disabled={isSubmitting} />
        <TradingAccountField 
          form={form}
          isLoading={isLoadingTradingAccounts}
          accounts={tradingAccounts}
          hasCspProfile={!!watchCspAccount}
          disabled={isSubmitting}
        />
        <VolumeMultiplierField form={form} disabled={isSubmitting} />
        <ReversePositionField form={form} />
        <FormActions 
          isSubmitting={isSubmitting}
          onCancel={onCancel}
        />
      </form>
    </Form>
  );
};
